const ADMIN_SESSION_KEY = "bcs_admin_session";

/** Mark the current browser tab as authenticated for admin routes. */
export function grantAdminSession() {
  sessionStorage.setItem(ADMIN_SESSION_KEY, "1");
}

/** Clear admin route access for this tab (public site visits, sign out). */
export function clearAdminSession() {
  sessionStorage.removeItem(ADMIN_SESSION_KEY);
}

/** True only after a successful sign-in in this tab. */
export function hasAdminSession() {
  return sessionStorage.getItem(ADMIN_SESSION_KEY) === "1";
}
